import { Injectable } from '@angular/core';
import { NotificationService, Notification } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class ToasterNotificationService {
  constructor(private readonly notificationService: NotificationService) {}

  receiveMessage(onMessage: (notification: Notification) => void) {
    this.notificationService.messages.subscribe((notification) => {
      if (notification && notification?.template?.name === 'toaster') {
        onMessage(notification);
      }
    });
  }
}
